import {
    Container,
    Sprite,
} from 'pixi.js';
import { Button, fonts, FocusManager, StyledBitmapText } from '../../ui';
import { GAMEPLAY } from '../../constants';
import { LoadContext } from '../../utils';
import { Tally } from './Tally';

export class BatTally extends Container
{
    private bg: Sprite;
    private title: StyledBitmapText;
    private subtitle: StyledBitmapText;
    private rescuedTallyTitle: StyledBitmapText;
    private rescuedTally: Tally;
    private remainingTallyTitle: StyledBitmapText;
    private remainingTally: Tally;
    private question: StyledBitmapText;
    public continue: Button;
    public endGame: Button;

    public static preload()
    {
        const loader = LoadContext.current;
        loader.add('ResultAtlas', './assets/result/ResultAtlas{size}.json');
        loader.add('brigit_tally', './assets/result/brigit_tally{size}.png');
        Tally.preload();
        Button.preload();
    }

    constructor(_levelNum: number, rescuedTotal: number)
    {
        super();

        const loader = LoadContext.current;

        this.bg = new Sprite(loader.getTexture('brigit_tally'));
        this.addChild(this.bg);

        rescuedTotal = Math.min(rescuedTotal, GAMEPLAY.TOTAL_BATS);
        const remaining = GAMEPLAY.TOTAL_BATS - rescuedTotal;

        const title = remaining === 0 ?
            `You\'ve rescued all ${rescuedTotal} bats!` :
            `You\'ve rescued ${rescuedTotal} bats!`;
        this.title = new StyledBitmapText(title, {tint: 0x000000, fontSize: 52, fontName: 'Asap'});
        this.title.anchor.set(0.5);
        this.title.position.set(1027, 206);
        this.addChild(this.title);

        let subtitle = remaining === 0 ?
            'No bats are trapped in the cave system.' :
            `${remaining} bats are still trapped in the cave system.`;
        this.subtitle = new StyledBitmapText(subtitle, {tint: 0x000000, fontSize: 39, fontName: 'AsapMedium'});
        this.subtitle.anchor.set(0.5);
        this.subtitle.position.set(1078, 283);
        this.addChild(this.subtitle);

        this.rescuedTallyTitle = new StyledBitmapText('Rescued', {tint: 0x000000, fontSize: 31, fontName: 'AsapMedium'});
        this.rescuedTallyTitle.anchor.set(0.5);
        this.rescuedTallyTitle.position.set(843, 365);
        this.addChild(this.rescuedTallyTitle);

        this.rescuedTally = new Tally(rescuedTotal);
        this.rescuedTally.position.set(682, 417);
        this.addChild(this.rescuedTally);

        this.remainingTallyTitle = new StyledBitmapText('Trapped', {tint: 0x000000, fontSize: 31, fontName: 'AsapMedium'});
        this.remainingTallyTitle.anchor.set(0.5);
        this.remainingTallyTitle.position.set(1307, 365);
        this.addChild(this.remainingTallyTitle);

        this.remainingTally = new Tally(remaining);
        this.remainingTally.position.set(1140, 417);
        this.addChild(this.remainingTally);

        this.question = new StyledBitmapText('What would you like to do next?', {tint: 0x000000, fontSize: 36, fontName: 'AsapMedium'});
        this.question.anchor.set(0.5);
        this.question.position.set(1081, 901);
        this.addChild(this.question);

        const buttonTex = loader.getTexture('btn_next', 'ResultAtlas');
        this.endGame = new Button(buttonTex, {
            // content: remaining === 0 ? 'Mission Accomplished' : `End the Mission`,
            content: 'End the Mission',
            style: fonts.SettingsIntroButton,
        });
        this.endGame.position.set(818, 997);
        this.addChild(this.endGame);
        this.endGame.on('pointertap', () => {
            this.endGame.enabled = false;
            this.continue.enabled = false;
            this.emit('exit');
        });

        this.continue = new Button(buttonTex, {
            content: `Rescue More Bats`,
            style: fonts.SettingsIntroButton,
        });
        this.continue.position.set(1318, 997);
        this.addChild(this.continue);
        this.continue.on('pointertap', () => {
            this.endGame.enabled = false;
            this.continue.enabled = false;
            this.continue.highlight = false;
            this.emit('continue');
        });
        if (remaining === 0)
        {
            this.continue.visible = false;
            this.endGame.x = 1068;
        }
    }

    public open()
    {
        FocusManager.instance.activateContext([this.endGame, this.continue]);
    }

    public get focus() { return [this.endGame, this.continue]; }

    public highlight()
    {
        if (this.continue.visible)
        {
            this.continue.highlight = true;
        }
        else
        {
            this.endGame.highlight = true;
        }
    }

    public destroy()
    {
        if (this.visible)
        {
            FocusManager.instance.popContext();
        }
        super.destroy({children: true});
    }
}